import { MouseEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { appActions, selectHomeMobileMenuShown } from '../../store/features/app'
import { AccentButton, BorderButton } from '../molecules/Button'

const Links = [
    {
        name: "Home",
        path: "/"
    },
    {
        name: "Features",
        path: "/#features"
    },
    {
        name: "Pricing",
        path: "/#pricing"
    },
    {
        name: "Contact Us",
        path: "/#contatc-us"
    },
    {
        name: "About",
        path: "/#about"
    },
    // {
    //     name: "Login",
    //     path: "/signin"
    // },
    // {
    //     name: "Register",
    //     path: "/register"
    // },
]

export default function HomeMobileMenu() {

    const dispatch = useDispatch()
    const history = useHistory()
    const isMobileMenuShown = useSelector(selectHomeMobileMenuShown)

    const handleLinkOnClick = (e:MouseEvent<HTMLAnchorElement> | undefined, linkPath: string)=>{

        e?.preventDefault()
        history.push(linkPath)
        dispatch(appActions.toggleHomeMobileMenuShown())

    }
    
    return (
        <>
            {
                isMobileMenuShown && (
                    <div
                        className='h-92.5 w-screen bg-primary absolute left-0 z-20 justify-center items-center hidden md:flex'
                    >
                            <ul className="flex flex-col justify-center items-center text-center list-none">
                                {
                                    Links.map((link)=>(

                                        <li className="mr-4 no-underline text-secondary2 text-lg mb-4">
                                            <Link 
                                                className='text-inherit' 
                                                to={link.path}
                                                onClick={(e)=>handleLinkOnClick(e, link.path)}
                                            >
                                                {link.name}
                                            </Link>
                                        </li>

                                    ))
                                }
                                <li className="mr-4 no-underline text-secondary2 text-lg mb-4">
                                    <BorderButton
                                        onClick={()=>handleLinkOnClick(undefined, "/signin")}
                                    >
                                        Open shop
                                    </BorderButton>
                                </li>
                                <li className="mr-4 no-underline text-secondary text-lg">
                                    <AccentButton
                                        onClick={()=>handleLinkOnClick(undefined, "/register")}
                                    >
                                        <span className="capitalize">
                                            Register shop
                                        </span>
                                    </AccentButton>
                                </li>
                            </ul>
                    </div>
                )
            }
        </>
    )
}
